export default __webpack_public_path__ + "static/media/Lora-VariableFont_wght.05e77ab0.ttf";